import type { AcquisitionKit } from '~/utils/installation/Installation'

export const ACQUISITION_KIT: Record<'SELECTED' | 'MIRROR' | 'CONTAINER' | 'OWN_EQUIPMENT' | 'VITRINE', AcquisitionKit> = {
  SELECTED: 'selected',
  MIRROR: 'mirror',
  CONTAINER: 'container',
  OWN_EQUIPMENT: 'own_equipment',
  VITRINE: 'vitrine',
}

/**
 * Display order of the options in the single toggle of the Equipment step.
 * `vitrine` is left out (always hidden for now).
 */
export const ACQUISITION_KIT_ORDER: AcquisitionKit[] = [
  ACQUISITION_KIT.MIRROR,
  ACQUISITION_KIT.SELECTED,
  ACQUISITION_KIT.CONTAINER,
  ACQUISITION_KIT.OWN_EQUIPMENT,
]

export const INVERTER_TYPE = {
  STRING: 'string',
  MICROINVERTER: 'microinverter',
} as const

export function getStoreBaseUrl(): string {
  return import.meta.env.MODE === 'production'
    ? 'https://loja.solfacil.com.br/'
    : 'https://stg-loja.solfacil.com.br/'
}

export function getBackofficeStoreOrderUrl(uuid?: string | null): string {
  const base = import.meta.env.MODE === 'production'
    ? 'https://backoffice-loja.solfacil.com.br'
    : 'https://stg-backoffice-loja.solfacil.com.br'
  return uuid ? `${base}/pedidos/${uuid}` : `${base}/pedidos`
}

export function toSystemPowerKwp(systemPowerW?: number | null): number {
  if (!systemPowerW || Number.isNaN(systemPowerW))
    return 0
  return systemPowerW / 1000
}
